import $ from 'jquery';
import select2 from 'select2/dist/js/select2.full.min.js';

$('.select2-dropdown').select2({
    width: "100%",
    theme: "simple",
    minimumResultsForSearch: -1,
    // containerCssClass: function (el) {
    //     if ($(el).hasClass('simple')) {
    //         return 'simple';
    //     } else {
    //         return "";
    //     }
    // },
    // dropdownCssClass: function (el) {
    //     if ($(el).hasClass('simple')) {
    //         return 'simple';
    //     } else {
    //         return "";
    //     }
    // }
}).focus(function () {
    $(this).select2('open');
});